import { usePosModeActions } from '@/features/pos/contexts/PosMode'
import { Stack, useFocusEffect } from 'expo-router'
import { FC, useCallback } from 'react'

const Layout: FC = () => {
    const { setPos } = usePosModeActions()

    useFocusEffect(
        useCallback(() => {
            setPos()
        }, [setPos])
    )

    return (
        <Stack screenOptions={{ headerShown: false }}>
            <Stack.Screen name="index" />
            <Stack.Screen name="new" />
            <Stack.Screen name="cash-transactions" />
        </Stack>
    )
}

export default Layout
